export default __webpack_public_path__ + "static/media/pwr_logo.35867bb6.png";